/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import React from "react";
import PropTypes from "prop-types";
import constants from "../../../common/utils/Constants";

const StatusIcon = (props) => {
  const {
    customer,
  } = props;
  const checkCustomerListStatus = () => {
    const { CUSTOMER_ACCOUNT_STATUS } = constants;
    const {
      classification, csr, mozcomUsers, salesRep,
    } = customer;

    const customerClassification = classification;
    const mozComUserName = mozcomUsers && mozcomUsers.map((mozcomUser) => (
      mozcomUser.name
    ));
    const userName = mozComUserName && mozComUserName[0];
    const mozComUserEmail = mozcomUsers && mozcomUsers.map((mozcomUser) => (
      mozcomUser.email
    ));
    const email = mozComUserEmail && mozComUserEmail[0];
    const csrName = csr && csr.name;
    const csrEmail = csr && csr.email;
    const csrPhoneDialCode = csr && csr.phone && csr.phone.dialCode;
    const csrPhoneNo = csr && csr && csr.phone && csr.phone.phoneNumber;
    const salesRepName = salesRep && salesRep.name;
    const salesRepEmail = salesRep && salesRep.email;
    const salesRepPhoneDialCode = salesRep && salesRep.phone && salesRep.phone.dialCode;
    const salesRepPhoneNo = salesRep && salesRep && salesRep.phone && salesRep.phone.phoneNumber;

    let status = CUSTOMER_ACCOUNT_STATUS.PARTIAL;

    if ((customerClassification !== null && customerClassification !== "")
      && (userName !== null && userName !== "")
      && (email !== null && email !== "")
      && (csrName !== null && csrName !== "")
      && (csrEmail !== null && csrEmail !== "")
      && (csrPhoneDialCode !== null && csrPhoneDialCode !== "")
      && (csrPhoneNo !== null && csrPhoneNo !== "")
      && (salesRepName !== null && salesRepName !== "")
      && (salesRepEmail !== null && salesRepEmail !== "")
      && (salesRepPhoneDialCode !== null && salesRepPhoneDialCode !== "")
      && (salesRepPhoneNo !== null && salesRepPhoneNo !== "")) {
      status = CUSTOMER_ACCOUNT_STATUS.COMPLETE;
    }

    if ((customerClassification === null || customerClassification === "")
      && (userName === null || userName === "")
      && (email === null || email === "")
      && (csrName === null || csrName === "")
      && (csrEmail === null || csrEmail === "")
      && (csrPhoneDialCode === null || csrPhoneDialCode === "")
      && (csrPhoneNo === null || csrPhoneNo === "")
      && (salesRepName === null || salesRepName === "")
      && (salesRepEmail === null || salesRepEmail === "")
      && (salesRepPhoneDialCode === null || salesRepPhoneDialCode === "")
      && (salesRepPhoneNo === null || salesRepPhoneNo === "")) {
      status = CUSTOMER_ACCOUNT_STATUS.NONE;
    }
    return status;
  };

  const updateStatusColor = checkCustomerListStatus();

  return (
    <div className={`${updateStatusColor}`}> </div>
  );
};

StatusIcon.propTypes = {
  customer: PropTypes.objectOf(PropTypes).isRequired,
};

export default StatusIcon;
